<template>
    <div class="gsgk">
        <div class="banner" v-cloak>
            <img class=" banner_img" src="../../static/img/jtgk_banner.png" alt="">
        </div>
        <div class="content" id="fz">
            <ul :class="{ active_nav : nav }" class="content_nav w1200">
                <li v-for=" (item, i) in jtNav" :key="i" @click="$router.push({ path: item.path }),active = i" :class="{ active1: active === i }"> {{item.navli}} </li>
            </ul>
            <div class="jt">
                <div class="jtjs w1200">
                    <div class="yc">1</div>
                    <div class="fzjs">
                        <h3>飞猪科技</h3>
                        <h4>ABOUT FEIZHU</h4>
                        <P id="ys" class="sj_text">北京飞猪科技有限公司是一家通过自主研发SaaS系统，为保险公司提供综合技术服务的金融科技企业，旗下全资控股协和万邦和方胜磐石保两家全国性保险经纪公司，产寿险年保费收入近100亿元。</P>
                    </div>
                    <div class="jtys">
                        <h3>优势</h3>
                        <h4>ABOUT ADVANTAGE</h4>
                        <div class="ys_img">
                            <img src="../../static/img/jtgk_ys.png" alt="">
                            <div class="yc_1" id="fzlc">a</div>

                        </div>
                    </div>
                    <div class="jtfz">
                        <h3>发展历程</h3>
                        <h4>ABOUT DEVELOPMENT</h4>
                        <div class="sjz">
                            <div class="sjz_t">
                                <ul class="sjz_ul">
                                    <li v-for="(item, b) in sjz" :key="b">
                                        <i class="icon_1"></i>
                                        <i class="icon_2 icon_1"></i>
                                        <h4>{{item.date}}</h4>
                                        <p>{{item.text}}</p>
                                        <li/>
                                </ul>
                                <div class="yc_3" id="gd">1</div>
                            </div>
                        </div>
                    </div>
                    <ul class="jtgd w1200" :class="{ygd : nav1}">
                        <li id="aa" @click="active3 = 0" :class="{ xiahx: active3 === 0 }">FESCO</li>
                        <li id="aa" @click="active3 = 1" :class="{ xiahx: active3 === 1 }">联合医务</li>
                        <li id="aa" @click="active3 = 2" :class="{ xiahx: active3 === 2 }">台湾磐石</li>
                    </ul>
                </div>
            </div>
            <div class="fesc_1" :class="{ fesc_2: nav1 }" v-for="(item,i) in $t('navbar.gudong')" :key="i" :id="item.id" v-if="active3===i">
                <i id="aboat">1</i>
                <div class="fesc_title">
                    <h2>{{item.gd_name}}</h2>
                    <h4>{{item.gd_name1}}</h4>
                </div>
                <div class="fesc_text ">
                    <img class="jtimg" :src="item.gd_img" />
                    <div class="p_1 w1200">
                        <p class="sj_text">{{item.gd_js1}}</p>
                        <p class="sj_text">{{item.gd_js2}}</p>
                        <p class="sj_text">{{item.gd_js3}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Gsgk',
  data () {
    return {
      nav: false,
      nav1: false,
      nav2: false,
      active: null,
      active3: 0,
      sjz: [
        {
          date: '2018.11',
          text: '北京飞猪科技正式与太平保险公司合作，迎来 又一个更大的改变'
        },
        {
          date: '2018.08',
          text: '北京飞猪科技正式与协诚保险公司合作，协保宝APP诞生'
        },
        {
          date: '2018.07',
          text: '北京飞猪科技与鼎和保险公司合作，鼎龙宝APP诞生'
        },
        {
          date: '2018.05',
          text: '北京飞猪科技与太平保险公司合作，太慧宝APP诞生'
        },
        {
          date: '2018.01',
          text: '北京飞猪科技年收入与去年相比成交率在不断增长'
        },
        {
          date: '2017.06',
          text: '北京飞猪科技正式与紫金保险公司合作，推出紫尊保APP'
        },
        {
          date: '2016.07',
          text: '推出联合保APP、热保APP'
        },
        {
          date: '2015.05',
          text: '北京飞猪科技有限公司成立'
        }

      ],
      jtNav: [
        {
          navli: '简介',
          path: '/jtgk?page=1#fz'
        },
        {
          navli: '优势',
          path: '/jtgk?page=1#ys'
        },
        {
          navli: '发展历程',
          path: '/jtgk?page=1#fzlc'
        },
        {
          navli: '股东介绍',
          path: '/jtgk?page=1#gd'
        }
      ]
    }
  },
  mounted () {
    //    let timeID = setInterval( _=> {
    //             if (this.isMobile()) {
    //             this.$router.push({ path: "/group" });
    //             } else {
    //             this.$router.push({ path: "/jtgk?page=1" });
    //             }
    //             clearInterval(timeID);
    //         }, 1000);
    this.isMobile()
    this.fesco()
    let navH = 540
    window.onscroll = _ => {
      var SH = document.body.scrollTop || document.documentElement.scrollTop//   console.log(SH)
      if (SH >= (navH - 20)) {
        this.nav = true
      } else {
        this.nav = false
      }
    }
   
  },
  methods: {
    fesco () {
      let fesco = this.$route.query.fesco
      if (fesco === undefined) {
        return
      }
      this.active3 = fesco - 0
    },
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        // return flag;
         if(flag){
        //    alert("mobile") 
            this.$router.push({ path: "/group" });
        }else{
            //  alert("pc")
             this.$router.push({ path: "/jtgk?page=1" });
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
    margin: 0 auto;
    max-width: 19.2rem;
    background: #0152a4;
    height: auto;
    color: #fffff6;
    .content_nav {
        height: 115px;
        color: #5f5f5f;
        line-height: 1.15rem;
        background-color: #eee;
        font-size: .22rem;
        display: flex;
        justify-content: space-around;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) translateY(-0.45rem);
        li {
            cursor: pointer;
        }
        a:active {
            color: #de101d;
        }
    }
    .active1 {
        color: red;
    }
    .active_nav {
        position: fixed;
        top: .1rem;
        left: 50%;
        transform: translateX(-50%) translateY(0);
        z-index: 1;
    }
    .jt {
        background: url(../../static/img/jt_jianjie.png);
        .jtjs {
            padding-top: 1rem;
            font-size: .24rem;
            h3 {
                font-size: .36rem;
                line-height: .55rem;
                text-align: center;
            }
            h4 {
                color: #b2d5fb;
                font-size: .2rem;
                line-height: .4rem;
                letter-spacing: .1rem;
                text-align: center;
            }
            .yc {
                opacity: 0;
            }
            .fzjs {
                p {
                    padding: .25rem;
                }
            }
            .jtys {
                padding: 10px 0;
                .ys_img {
                    padding: .25rem 0;
                }
                .yc_1 {
                    opacity: 0;
                    position: relative;
                    top: -.8rem;
                }
            }
            .sjz {
                position: relative;
                height: 12.9rem;
                padding-bottom: .6rem;
                .sjz_t {
                    width: .1rem;
                    height: 12.9rem;
                    background-color: #f44540;
                    position: absolute;
                    top: .2rem;
                    left: 50%;
                    transform: translateX(-50%);
                    .sjz_ul {
                        position: absolute;
                        top: .3rem;
                        li {
                            width: 6.25rem;
                            height: 1.50rem;
                            text-align: left;
                            box-sizing: border-box;
                            position: relative;
                            font-size: .28rem;
                            color: #76b4ed;
                            h4 {
                                letter-spacing: 0px;
                                font-size: .3rem;
                                color: #fff;
                                text-align: left;
                                padding: .25rem .4rem 0 .4rem;
                            }
                            p {
                                padding: .25rem .4rem 0 .4rem;
                            }
                            .icon_1 {
                                width: .14rem;
                                height: .14rem;
                                border-radius: 50%;
                                background-color: #2e88e9;
                                position: absolute;
                                left: -2px;
                            }
                            .icon_2 {
                                width: 3.12rem;
                                height: .05rem;
                                border-radius: .05rem;
                                top: 4.5px;
                            }
                        }
                        li:hover {
                            opacity: 0.6;
                        }
                        li:nth-child(even) {
                            left: -6.15rem;
                            text-align: right;
                            .icon_1 {
                                left: auto;
                                right: -2px;
                            }
                            h4 {
                                text-align: right;
                            }
                        }
                    }
                    .yc_3 {
                        position: relative;
                        top: 11.80rem;
                        opacity: 0;
                    }
                }
            }
            .jtgd {
                margin: .7rem 0;
                height: .5rem;
                box-sizing: border-box;
                display: flex;
                padding-bottom: .07rem;
                justify-content: space-between;
                border-bottom: 5px solid #318ae8;
                li {
                    height: .5rem;
                    color: #a0d4ff;
                    box-sizing: border-box;
                    cursor: pointer;
                }
                .xiahx {
                    border-bottom: 5px solid #fff;
                    color: #fff8f2;
                }
            }
        }
    }
    .gdlist {
        background-color: #ccc;
    }
    .fesc_2 {
        margin-top: 1.9rem;
    }
    .fesc_1 {
        position: relative;
        #aboat {
            position: absolute;
            top: -4rem;
            width: 0;
            height: 0;
            overflow: hidden;
        }
        .fesc_title {
            height: 1.80rem;
            font-size: .24rem;
            text-align: center;
            background: #de101d;
            h2 {
                font-size: .36rem;
                line-height: .6rem;
                padding-top: .5rem;
            }
            h4 {
                font-size: .2rem;
                line-height: .28rem;
                color: #fcc4c7;
                letter-spacing: .1rem;
            }
        }
    }
    .fesc_text {
        max-width: 19.2rem;
        margin: 0 auto;
        position: relative;
        .p_1 {
            padding: .4rem 0;
            p {
                padding: .2rem 0;
                line-height: .36rem;
                font-size: .26rem;
                color: #e1f8ff;
            }
        }
        .jtimg {
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Jtgk.vue